'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountries = undefined;

var _sagaTools = require('@classpass/saga-tools');

var getCountries = exports.getCountries = (0, _sagaTools.makeEntityScaffold)('SAGA.API.GET_COUNTRIES', function (client) {
  return client.countries.get().then(function (data) {
    return data.countries;
  });
});